(function () {
  if (window.__altSizeBound) return;
  window.__altSizeBound = true;

  function cartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return '/cart/add.js';
  }

  function openDrawer(addPayload) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && addPayload && addPayload.sections && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(addPayload, true);
        return;
      } catch (e) {}
    }
    if (drawer && typeof drawer.refreshCartDrawer === 'function') {
      Promise.resolve(drawer.refreshCartDrawer()).then(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      }).catch(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      });
      return;
    }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
  }

  async function fillImage(media) {
    var handle = media.getAttribute('data-handle');
    if (!handle || media.querySelector('img')) return;
    try {
      var res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      var product = await res.json();
      if (!product.featured_image) return;
      var img = document.createElement('img');
      img.src = product.featured_image;
      img.alt = product.title || '';
      img.width = 64;
      img.height = 64;
      img.loading = 'lazy';
      media.appendChild(img);
    } catch (e) {}
  }

  function toLinkOnly(card) {
    card.setAttribute('data-validated', 'fail');
    card.removeAttribute('data-variant-id');
    var btn = card.querySelector('[data-alt-size-atc]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('hidden', '');
      btn.setAttribute('aria-hidden', 'true');
    }
    var link = card.querySelector('[data-alt-size-link]');
    if (link) {
      link.removeAttribute('hidden');
    } else {
      var url = card.getAttribute('data-product-url');
      var actions = card.querySelector('.alt-size__actions');
      if (url && actions) {
        var a = document.createElement('a');
        a.className = 'alt-size__link';
        a.setAttribute('data-alt-size-link', '');
        a.href = url;
        a.textContent = 'View';
        actions.insertBefore(a, actions.firstChild);
      }
    }
  }

  async function validateStaticCard(card) {
    var expectedHandle = card.getAttribute('data-expected-handle');
    var variantId = card.getAttribute('data-variant-id');
    if (!expectedHandle || !variantId) {
      card.setAttribute('data-validated', 'ok');
      return;
    }
    try {
      var res = await fetch('/products/' + encodeURIComponent(expectedHandle) + '.js', {
        headers: { Accept: 'application/json' }
      });
      // Fail OPEN on network/HTTP — keep ATC (qty 6)
      if (!res.ok) {
        card.setAttribute('data-validated', 'ok');
        return;
      }
      var product = await res.json();
      if (!product || (product.handle && product.handle !== expectedHandle)) {
        toLinkOnly(card);
        return;
      }
      var variants = product.variants || [];
      var ok = variants.some(function (v) { return String(v.id) === String(variantId); });
      if (!ok) {
        toLinkOnly(card);
        return;
      }
      card.setAttribute('data-validated', 'ok');
    } catch (e) {
      // Fail OPEN on fetch error
      card.setAttribute('data-validated', 'ok');
    }
  }

  async function readCartVariantQty(variantId) {
    try {
      var res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) return null;
      var cart = await res.json();
      var qty = 0;
      (cart.items || []).forEach(function (item) {
        if (String(item.variant_id) === String(variantId) || String(item.id) === String(variantId)) {
          qty += item.quantity || 0;
        }
      });
      return qty;
    } catch (e) {
      return null;
    }
  }

  async function postAdd(items) {
    // Items-only body. Do not request sections — section HTML can break success parsing.
    var res = await fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    });
    var ct = (res.headers.get('content-type') || '').toLowerCase();
    var text = await res.text();
    var json = {};
    if (ct.indexOf('application/json') !== -1 || (text && text.charAt(0) === '{')) {
      try { json = JSON.parse(text); } catch (e) { json = {}; }
    }
    if (json.items && json.items.length) {
      return { ok: true, json: json };
    }
    if (!res.ok || json.status) {
      return {
        ok: false,
        json: json,
        error: json.description || json.message || res.statusText || 'Could not add to cart.'
      };
    }
    return { ok: true, json: json };
  }

  async function addOne(card, button) {
    var err = card.querySelector('[data-alt-size-error]');
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }

    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    if (card.getAttribute('data-validated') === 'fail') {
      if (err) {
        err.hidden = false;
        err.textContent = 'Product unavailable — use View instead.';
      }
      return;
    }

    // If validation still pending, try once more; fail-open
    if (card.getAttribute('data-expected-handle') && card.getAttribute('data-validated') !== 'ok') {
      await validateStaticCard(card);
      if (card.getAttribute('data-validated') === 'fail') {
        if (err) {
          err.hidden = false;
          err.textContent = 'Product unavailable — use View instead.';
        }
        return;
      }
    }

    var variantId = card.getAttribute('data-variant-id');
    var qty = parseInt(card.getAttribute('data-qty') || '6', 10) || 6;
    if (!variantId) {
      if (err) {
        err.hidden = false;
        err.textContent = 'No sellable variant.';
      }
      return;
    }

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    var items = [{ id: Number(variantId), quantity: qty }];
    var beforeQty = await readCartVariantQty(variantId);

    try {
      var result;
      try {
        result = await postAdd(items);
      } catch (networkErr) {
        // Retry ONLY when fetch itself rejects (no HTTP response).
        try {
          result = await postAdd(items);
        } catch (networkErr2) {
          result = { ok: false, json: {}, error: 'Could not add to cart (network). Try again or use View.' };
        }
      }

      if (!result.ok) {
        // HTTP/body failure: check whether cart already changed before showing error.
        var afterFail = await readCartVariantQty(variantId);
        if (afterFail !== null && beforeQty !== null && afterFail >= beforeQty + qty) {
          result = { ok: true, json: result.json || {} };
        } else if (afterFail !== null && beforeQty === null && afterFail >= qty) {
          result = { ok: true, json: result.json || {} };
        } else {
          throw new Error(result.error || 'Could not add to cart.');
        }
      }

      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { items: items } }));
      openDrawer(result.json);
    } catch (e) {
      if (err) {
        err.hidden = false;
        err.textContent = e && e.message ? e.message : 'Could not add to cart.';
      }
    } finally {
      button.removeAttribute('aria-busy');
      if (!card.classList.contains('alt-size__card--oos') && card.getAttribute('data-validated') !== 'fail') {
        button.disabled = false;
      }
    }
  }

  function bind(root) {
    root.querySelectorAll('[data-alt-size-media][data-handle]').forEach(fillImage);
    root.querySelectorAll('[data-alt-size-card]').forEach(function (card) {
      if (card.getAttribute('data-expected-handle') && card.getAttribute('data-variant-id')) {
        validateStaticCard(card);
      } else {
        card.setAttribute('data-validated', 'ok');
      }
      var btn = card.querySelector('[data-alt-size-atc]');
      if (!btn || btn.__altBound) return;
      btn.__altBound = true;
      btn.addEventListener('click', function () { addOne(card, btn); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-alt-size]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
